import EAAccordion from "../../EAAccordion";
import * as PropTypes from "prop-types";
import React from "react";
import {
    DurchflusspruefungValues,
    JahresberichtValues,
    KanalzustandValues,
    StatusParameterMesswerte
} from "../../../consts/valueLists";

const id = "erweiterteSuche";
/**
 * Attribute im Filter
 */
const attr = {
    berichtsjahrVon: "berichtsjahrVon",
    berichtsjahrBis: "berichtsjahrBis",
    statusMesswerte: "statusMesswerte",
    statusJahresbericht: "statusJahresbericht",
    kanalzustand: "kanalzustand",
    durchflusspruefung: "durchflusspruefung",
    regionalstelle: "regionalstelle"
};

function ErweiterteSucheJahresbericht(props) {
    const currentYear = new Date().getFullYear();
    let yearOptions = [];
    for (let year = 2020; year <= currentYear; year++) {
        yearOptions.push({value: year.toString(), id: year});
    }

    return (
        <EAAccordion
            label="Erweiterte Suche"
            wrapperClassName="extendedFilter"
            className="gridl extendedFilter"
            id={id}
            variant="light"
            expanded={props.sharedFilter.extendedSearchOpen ? props.sharedFilter.extendedSearchOpen : false}
            onChange={(_e, expanded) => props.onExtendedSearchOpenChanged(expanded)}
        >
            {React.Children.toArray(props.additionalPrefixFields)}
            {props.sharedFormFactory.renderAutocomplete(
                attr.berichtsjahrVon,
                attr.berichtsjahrVon,
                "Berichtsjahr von",
                yearOptions,
                "value",
                "id",
                false
            )}{props.sharedFormFactory.renderAutocomplete(
                attr.berichtsjahrBis,
                attr.berichtsjahrBis,
                "Berichtsjahr bis",
                yearOptions,
                "value",
                "id",
                false
            )}
            {props.sharedFormFactory.renderAutocomplete(
                attr.statusMesswerte,
                attr.statusMesswerte,
                "Status Messwerte",
                StatusParameterMesswerte,
                "value",
                "id",
                false
            )}
            {props.sharedFormFactory.renderAutocomplete(
                attr.statusJahresbericht,
                attr.statusJahresbericht,
                "Status Jahresbericht",
                JahresberichtValues,
                "value",
                "id",
                false
            )}
            {props.sharedFormFactory.renderAutocomplete(
                attr.kanalzustand,
                attr.kanalzustand,
                "Kanalzustand/Sanierung",
                KanalzustandValues,
                "value",
                "id",
                false
            )}
            {props.sharedFormFactory.renderAutocomplete(
                attr.durchflusspruefung,
                attr.durchflusspruefung,
                "Durchflussprüfung an",
                DurchflusspruefungValues,
                "value",
                "id",
                false
            )}
            {props.sharedFormFactory.renderAutocomplete(
                attr.regionalstelle,
                id + "-" + attr.regionalstelle,
                "Regionalstelle",
                props.regionalstelleOptionen.data,
                "value",
                "id",
                props.regionalstelleOptionen.loading
            )}
        </EAAccordion>
    );
}

export default ErweiterteSucheJahresbericht;
ErweiterteSucheJahresbericht.propTypes = {
    onExtendedSearchOpenChanged: PropTypes.func,
    formFactory: PropTypes.any,
    additionalPrefixFields: PropTypes.any,
    additionalSuffixFields: PropTypes.any,
};
